var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { to } from "@lib/utils";
import detectEthereumProvider from "@metamask/detect-provider";
import { Network } from "@models/network";
import { Wallet } from "@models/wallet";
import * as Sentry from "@sentry/browser";
import Web3 from "web3";
import { signingMessage, WalletError } from "./utils";
import { connectWalletWCByConnector, } from "./walletconnect";
export const connectWalletMetamaskMobile = (connector) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "connectWalletMetamaskMobile",
        level: "info",
    });
    console.log("connectWalletMetamaskMobile", connector === null || connector === void 0 ? void 0 : connector.uri);
    if (!connector)
        throw WalletError.UNKNOWN_ERROR;
    console.log("connectWalletMetamaskMobile", connector.accounts);
    if (connector.connected && connector.accounts.length == 1)
        return { walletAddress: connector.accounts[0], connector };
    console.log("connectWalletMetamaskMobile", "connectWalletWCByConnector");
    const { err, res: connectWalletResponse } = yield to(connectWalletWCByConnector(connector));
    console.log("connectWalletMetamaskMobile", connectWalletResponse);
    if (err || !connectWalletResponse)
        throw err || WalletError.UNKNOWN_ERROR;
    return connectWalletResponse;
});
export const connectWalletMetamask = () => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "connectWalletMetamask",
        level: "info",
    });
    const provider = yield detectEthereumProvider({
        mustBeMetaMask: true,
    });
    if (!provider)
        throw WalletError.METAMASK_NOT_INSTALLED;
    // const { err: chainErr, res: chainId } = await to(
    //   provider.request({
    //     method: "eth_chainId",
    //   })
    // );
    // if (chainErr) throw WalletError.UNKNOWN_ERROR;
    // if (chainId != "0x1") throw WalletError.NOT_MAINNET;
    let accountErr;
    let accounts;
    ({ err: accountErr, res: accounts } = yield to(provider.request({
        method: "eth_requestAccounts",
    })));
    /*
        eth_accounts returns an array that is either empty or contains a single account address. The returned address, if any, is the address of the most recently used account that the caller is permitted to access. Callers are identified by their URL origin, which means that all sites with the same origin share the same permissions.
        */
    if (accountErr || !accounts || accounts.length != 1) {
        if ((accountErr === null || accountErr === void 0 ? void 0 : accountErr.code) == 4001)
            throw WalletError.REQUEST_DENIED;
        throw WalletError.UNKNOWN_ERROR;
    }
    const [walletAddress] = accounts;
    console.log("eth_requestAccounts", walletAddress);
    return { walletAddress: walletAddress };
});
export const verifyWalletMetamask = (connectWalletResponse) => __awaiter(void 0, void 0, void 0, function* () {
    Sentry.addBreadcrumb({
        category: "verifyWalletMetamask",
        level: "info",
    });
    const { walletAddress: walletAddress } = connectWalletResponse;
    const web3 = new Web3(Web3.givenProvider);
    if (!web3)
        throw WalletError.UNKNOWN_ERROR;
    const message = signingMessage();
    const { err: signErr, res: signature } = yield to(web3.eth.personal.sign(message, walletAddress, ""));
    if (signErr || !signature) {
        if ((signErr === null || signErr === void 0 ? void 0 : signErr.code) == 4001)
            throw WalletError.REQUEST_DENIED;
        throw WalletError.UNKNOWN_ERROR;
    }
    const { err: recoverErr, res: address } = yield to(web3.eth.personal.ecRecover(message, signature));
    if (recoverErr || !address)
        throw WalletError.UNKNOWN_ERROR;
    if (address.toLowerCase() != walletAddress.toLowerCase())
        throw WalletError.UNVERIFIED;
    return new Wallet({ network: Network.ETHEREUM, address, verified: true });
});
